import script from "./SlidernewDesktopYoutube.vue?vue&type=script&setup=true&lang=js"
export * from "./SlidernewDesktopYoutube.vue?vue&type=script&setup=true&lang=js"

import "./SlidernewDesktopYoutube.vue?vue&type=style&index=0&id=39eeac96&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39eeac96"]])

export default __exports__